export default "__VITE_ASSET__BrTj8oCC__"